// extracted by mini-css-extract-plugin
export var notificationHost = "_lq-0";